import { Component } from 'preact';
import style from './styles/FormSteps.scss';
import RegistrationStep from '../../../enums/RegistrationStep';
import FormStep from './FormStep';

/**
 * @typedef {Object} FormStepConfig
 * @property {string}    name                    Step name
 * @property {string}    image                   Image
 * @property {number}    underlineLeftPosition   Steps considered active
 */

/**
 * @property {FormStepConfig[]}         props.steps
 * @property {string[]}                 props.checkedSteps
 */
export default class FormSteps extends Component {

	steps = [
		{
			name: RegistrationStep.CUSTOMER.value,
			image: '/assets/images/icons/form-icon-customer-active.png',
			underlineLeftPosition: 0
		},
		{
			name: RegistrationStep.SUMMARY.value,
			image: '/assets/images/icons/form-icon-summary-active.png',
			underlineLeftPosition: 33.33
		},
		{
			name: RegistrationStep.PAYMENT.value,
			image: '/assets/images/icons/form-icon-payment-active.png',
			underlineLeftPosition: 66.66
		}
	];

	/**
	 * @param {string} activeStep
	 * @return {FormStepConfig}
	 */
	getActiveStep(activeStep) {
		return this.steps.find((step) => step.name === activeStep.value);
	}

	render({ activeStep, checkedSteps }) {
		const activeStepConfig = this.getActiveStep(activeStep);
		const stepCount = this.steps.length;

		return (
			<div className={`row ${style.steps}`}>
				{ this.steps.map((step, i) =>
					<FormStep {...{ step, activeStep: activeStepConfig.name, hasArrow: (i + 1)  < stepCount, checked: checkedSteps.includes(step.name) }} />
				)}
				<div className={`col-12 ${style['underline-wrapper']}`}>
					{ activeStepConfig ?
						<div className={style.active} style={`left: ${activeStepConfig.underlineLeftPosition}%;`} /> :
						null
					}
					<div className={style.underline} />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/blocks/raffleForm/FormSteps.js